import React from 'react';
import { formatMB } from '../../../shared/utils/fileFormat.js';

// Único uso, junto con el aviso de límite, del ámbar como relleno sólido de
// barra: excepción documentada (RN-001, escenario 4). Los tres segmentos
// usan tonos de la familia ámbar para conservar la distinción por tipo de
// archivo sin salirse de esa excepción.
const SEGMENTS = [
  { key: 'images', label: 'Imágenes', barClass: 'bg-amber-dark', dotClass: 'bg-amber-dark' },
  { key: 'documents', label: 'Documentos', barClass: 'bg-amber', dotClass: 'bg-amber' },
  { key: 'other', label: 'Otros', barClass: 'bg-amber-hover', dotClass: 'bg-amber-hover' }
];

const StorageBreakdownBar = ({ storage }) => {
  const other = Math.max(storage.used - storage.images - storage.documents, 0);
  const values = { images: storage.images, documents: storage.documents, other };
  const widthPct = (value) => (storage.limit > 0 ? (value / storage.limit) * 100 : 0);

  return (
    <div className="mt-6">
      <div className="w-full h-3.5 rounded-full overflow-hidden bg-line flex">
        {SEGMENTS.map((seg) => (
          <div key={seg.key} className={seg.barClass} style={{ width: `${widthPct(values[seg.key])}%` }} />
        ))}
      </div>

      <div className="flex flex-wrap gap-5 mt-3 text-sm text-content">
        {SEGMENTS.map((seg) => (
          <div key={seg.key} className="flex items-center gap-2">
            <span className={`w-2.5 h-2.5 rounded-full ${seg.dotClass}`} />
            {seg.label} — <b className="text-content font-semibold">{formatMB(values[seg.key])}</b>
          </div>
        ))}
        <div className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 rounded-full bg-line" />
          Disponible — <b className="text-content font-semibold">{formatMB(storage.free)}</b>
        </div>
      </div>
    </div>
  );
};

export default StorageBreakdownBar;
